import React, { FC } from 'react';
import BEMHelper from 'react-bem-helper';
import { Input as AntdInput } from 'antd';
import { Props } from './interfaces';
import SubmitSuffix from './submitSuffix';

import './styles.scss';

const classes = new BEMHelper({
  name: 'input',
  outputIsString: true,
});

const Input: FC<Props> = ({
  className,
  size,
  disabled = false,
  error = false,
  withSubmit,
  onSubmit,
  widthBorderRadius,
  ...otherProps
}) => {
  return (
    <AntdInput
      {...otherProps}
      disabled={disabled}
      className={`${classes('', {
        [size ? size.toString() : '']: true,
        error,
        'with-border-radius': Boolean(widthBorderRadius),
      })} ${className || ''}`}
      suffix={
        withSubmit && onSubmit ? <SubmitSuffix onSubmit={onSubmit} /> : null
      }
    />
  );
};

export default Input;
